package com.ai.mitra.di

import com.ai.mitra.data.database.SharedDatabase
import org.koin.dsl.module

val databaseModule = module {
    single { DatabaseDriverFactory() }
    single { SharedDatabase(get()) }
}